import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { PaymentMethod } from '@/api/types/payments.types';
import { PaymentInTerminals } from '@/components/Payment/PaymentInTerminals';
import {
  checkHashOnTerminalPayment,
  parseHashStringForTerminal,
} from '@/components/Payment/PaymentInTerminals.helpers';
import { useTerminalPayment } from '@/components/Payment/useTerminalPayment';
import { useUrlAndHashFromPath } from '@/hooks/useUrlAndHashFromPath';
import { buildServiceIdForService } from '@/components/Ad/Promotions/PromotionDrawer.helpers';

interface PaymentInTerminalsAfterAuthProps {
  adId?: string;
}
export const PaymentInTerminalsAfterAuth = ({
  adId,
}: PaymentInTerminalsAfterAuthProps) => {
  const router = useRouter();
  const { url, hash } = useUrlAndHashFromPath();
  const shouldCreateTerminalPayment = checkHashOnTerminalPayment(hash);
  const { isTerminalOpen, toggleTerminal, createTerminalPayment } =
    useTerminalPayment({ payment: PaymentMethod.Terminal });

  function closePaymentInTerminalsWindow() {
    toggleTerminal(false);
    router.replace(url);
  }

  useEffect(() => {
    if (shouldCreateTerminalPayment && adId) {
      const { service, serviceType } = parseHashStringForTerminal(hash) || {};

      if (service && serviceType !== undefined) {
        createTerminalPayment({
          variables: {
            serviceId: buildServiceIdForService(service, serviceType),
            targetId: adId,
          },
        });
      }
    }
  }, [shouldCreateTerminalPayment, adId]);

  return (
    <PaymentInTerminals
      isOpen={isTerminalOpen}
      toggle={closePaymentInTerminalsWindow}
    />
  );
};
